const Gallery = () => {
  const images = [
    {
      url: 'https://static.readdy.ai/image/dd95bba129a4e648d9c1ab0ceae0e9b1/d44ea4905080ab9b232b3740d9b93930.jpeg',
      title: 'Zona de Descanso',
      description: 'Espacio acogedor para los más pequeños'
    },
    {
      url: 'https://static.readdy.ai/image/dd95bba129a4e648d9c1ab0ceae0e9b1/f954a84ce013939e2f8f93d98ef3df80.jpeg',
      title: 'Zona de Aprendizaje',
      description: 'Ambiente estimulante y colorido'
    },
    {
      url: 'https://static.readdy.ai/image/dd95bba129a4e648d9c1ab0ceae0e9b1/15f595a8b3ca18257d3c5e8c610e74b2.jpeg',
      title: 'Zona de Juego Simbólico',
      description: 'Cunas cómodas y seguras'
    },
    {
      url: 'https://public.readdy.ai/ai/img_res/edited_2f8697e81bf4184535a6df3b5e1629f8_e0fa8d40.jpg',
      title: 'Zona de Psicomotricidad',
      description: 'Diversión y desarrollo motor'
    }
  ];

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Nuestra Galería</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Descubre nuestras instalaciones diseñadas para el bienestar y desarrollo de los más pequeños
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={image.url}
                  alt={image.description}
                  className="w-full h-full object-cover object-center transform group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-white text-xl font-semibold">{image.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
